<!-- Main Content -->
<div class="container mt-4">
  <!-- Title with Icon -->
  <h1 class="h3 mb-2 text-gray-800">
    <i class="fas fa-building mr-2"></i> Phòng Ban
  </h1>

  <!-- Description Below Title -->
  <p class="lead mb-4">
    Quản lý và xem thông tin về các phòng ban trong tổ chức. Điều hướng qua các tab để xem các tổng quan khác nhau, danh sách chi tiết và hướng dẫn sử dụng. Sử dụng nút "Thêm Phòng Ban" để thêm các phòng ban mới vào danh sách.
  </p>

  <!-- Navigation Tabs -->
  <ul class="nav nav-tabs">
    <li class="nav-item">
      <a class="nav-link active" data-toggle="tab" href="#List">
        <i class="fas fa-list mr-2"></i> Danh Sách
      </a>
    </li>
    <li class="nav-item">
      <a class="nav-link" data-toggle="tab" href="#UserManual">
        <i class="fas fa-book mr-2"></i> Hướng Dẫn Sử Dụng
      </a>
    </li>
  </ul>

  <!-- Tab Content -->
  <div class="tab-content">
    <!-- List tab content -->
    <div id="List" class="tab-pane fade show active">
      <div class="container-fluid">
        <br/>

        <!-- Department Table -->
        <div class="card mb-4">
          <div class="card-body">
            <div class="table-responsive">

              <div *ngIf="loadingIndicator; else loaded">
                <app-loading></app-loading>
              </div>

              <ng-template #loaded>

                <button class="btn btn-outline-primary btn-icon-split mb-3" (click)="openAddDialog()">
                  <span class="icon text-white-50">
                    <i class="fas fa-plus"></i>
                  </span>
                  <span class="text">Thêm Phòng Ban</span>
                </button>

                <button class="btn btn-outline-info btn-icon-split mb-3" (click)="refreshData()">
                  <span class="icon text-white-50">
                    <i class="fas fa-sync-alt"></i>
                  </span>
                  <span class="text">Làm Mới</span>
                </button>

                <div>
                  <input
                    type="text"
                    class="form-control"
                    placeholder="Tìm kiếm theo tên..."
                    (input)="updateFilter($event)"
                  />
                </div>

                <ngx-datatable
                  class="bootstrap"
                  [rows]="departments"
                  [columnMode]="'force'"
                  [headerHeight]="50"
                  [footerHeight]="50"
                  [rowHeight]="'auto'"
                  [limit]="10"
                  [loadingIndicator]="loadingIndicator"
                  [reorderable]="reorderable"
                  (select)="onSelect($event)"
                  (activate)="onActivate($event)">

                  <!-- Department Name -->
                  <ngx-datatable-column name="Tên Phòng Ban" [prop]="'departmentName'">
                    <ng-template ngx-datatable-cell-template let-row="row">
                     <span style="color: red;">{{ row.departmentName }}</span> 
                    </ng-template>
                  </ngx-datatable-column>

                  <!-- Department Code -->
                  <ngx-datatable-column name="Mã Phòng Ban" [prop]="'departmentCode'">
                    <ng-template ngx-datatable-cell-template let-row="row">
                      <span style="color: green;">{{ row.departmentCode }}</span>
                    </ng-template>
                  </ngx-datatable-column>

                  <!-- Head of Department -->
                  <ngx-datatable-column name="Trưởng Phòng" [prop]="'headOfDepartment'">
                    <ng-template ngx-datatable-cell-template let-row="row">
                      {{ row.headOfDepartment }}
                    </ng-template>
                  </ngx-datatable-column>

                  <!-- Location -->
                  <ngx-datatable-column name="Vị Trí" [prop]="'location'">
                    <ng-template ngx-datatable-cell-template let-row="row">
                      {{ row.location }}
                    </ng-template>
                  </ngx-datatable-column>

                  <!-- Phone -->
                  <ngx-datatable-column name="Điện Thoại" [prop]="'phone'">
                    <ng-template ngx-datatable-cell-template let-row="row">
                      {{ row.phone }}
                    </ng-template>
                  </ngx-datatable-column>

                  <!-- Email -->
                  <ngx-datatable-column name="Email" [prop]="'email'">
                    <ng-template ngx-datatable-cell-template let-row="row">
                      {{ row.email }}
                    </ng-template>
                  </ngx-datatable-column>

                  <!-- Number of Employees -->
                  <ngx-datatable-column name="Số Nhân Viên" [prop]="'numberOfEmployees'">
                    <ng-template ngx-datatable-cell-template let-row="row">
                      {{ row.numberOfEmployees }}
                    </ng-template>
                  </ngx-datatable-column>

                  <!-- Actions -->
                  <ngx-datatable-column name="Hành Động">
                    <ng-template ngx-datatable-cell-template let-row="row">
                      <button class="btn btn-outline-secondary dropdown-toggle btn-sm" type="button" id="dropdownMenuButton" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                        Hành Động
                      </button>
                      <div class="dropdown-menu" aria-labelledby="dropdownMenuButton">
                        <a class="dropdown-item" (click)="openEditDialog(row)" title="Chỉnh Sửa">
                          <i class="fas fa-edit"></i> Chỉnh Sửa
                        </a>
                        <a class="dropdown-item" (click)="deleteRow(row)" title="Xóa">
                          <i class="fas fa-trash"></i> Xóa
                        </a>
                      </div>
                    </ng-template>
                  </ngx-datatable-column>
                </ngx-datatable>

              </ng-template>

            </div>
          </div>
        </div>
      </div>
    </div>
    <div id="UserManual" class="tab-pane custom-tab-pane">
      <!-- User Manual content here -->
      <div [innerHTML]="markdownContent"></div>
  </div>
  </div>
</div>

